import { Component, SimpleChange, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AllContentModel, ContentModel } from 'src/app/model/files.model';
import { CommonService } from 'src/app/services/common.service';
import { MyFilesService } from 'src/app/services/myfiles.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-allfiles',
  templateUrl: './allfiles.component.html',
  styleUrls: ['./allfiles.component.scss'],
  providers:[MessageService]
})
export class AllfilesComponent {
  allfiles: any;
  files: any;
  id: any;
  lang: any= [];

  constructor(private myFileService: MyFilesService, private router: Router, private commonService: CommonService, private messageService:MessageService) {
  }

  ngOnInit() {
    this.get_user_files();
    this.commonService.allFiles.subscribe((fileData: any) => {
      if (fileData != "") {
        this.allfiles = fileData
        this.allfiles = fileData.filter((file: any) => { return !file.created_by.toLowerCase().includes('undefined') });
        this.files = this.allfiles;
        // this.files.forEach((file:any)=>{
        //   this.lang[file?._id] = file?.outputs?.translation;
        // })
      }
    });
  }

  get_user_files(){
    this.commonService.loggedInUser.subscribe((user:any)=>{
      if(user.userPrincipalName!=undefined){
        this.myFileService.getAllContents(user.userPrincipalName).subscribe((files: AllContentModel) => {
          this.commonService.allFiles.next(files.response);
        });
      }
    })
  }
  
  goHome() {
    this.router.navigateByUrl("/AudioTranslation");
  }

  get_languages(translations: any) {
    return Object.keys(translations);
  }

  viewOutput(file: any) {
    this.commonService.from_my_files = 2;
    this.router.navigateByUrl("/AudioTranslation/reviewspeaker/" + file._id);
    this.commonService.currentSelectedFileData.next(file);
  }

  get_each_language(translations: any) {
    let languages = Object.keys(translations);
    let language_object = {
      languages: '',
      remaining_length: 0,
      remaining_languages: ''
    }

    if (languages.length == 0) {
      return language_object;
    }


    let languages_to_be_visible = 3;

    if (languages.length > languages_to_be_visible) {

      for (let i = 0; i < languages_to_be_visible; i++) {
        language_object.languages += this.get_title_case(languages[i]) + ', '
      }

      language_object.remaining_length = languages.length - languages_to_be_visible;

      for (let i = languages.length - 1; i >= languages_to_be_visible; i--) {
        language_object.remaining_languages += this.get_title_case(languages[i]) + ', '
      }

    } else {
      let temp='';
      languages.forEach((language: any) => {
        temp = temp + this.get_title_case(language) + ", "
      });
      language_object.languages = temp;
    }

    if (language_object.languages.endsWith(', '))
      language_object.languages = language_object.languages.slice(0, language_object.languages.length - 2)

    if (language_object.remaining_languages.endsWith(', '))
      language_object.remaining_languages = language_object.remaining_languages.slice(0, language_object.remaining_languages.length - 2)

    return language_object;
  }

  get_title_case(input_string: any) {
    if (input_string == undefined) {
      return '';
    }
    return input_string.replace(/\w\S*/g, (w: any) => w.charAt(0).toUpperCase() + w.substr(1).toLowerCase());
  }

  rows = 10;

  search(text: string) {
    this.files = this.allfiles.filter((file: any) => { return file.event_details.name.toLowerCase().includes(text.toLowerCase()) });
  }

  shouldShowPaginator(): boolean {
    if (this.files.length > this.rows) {
      return true;
    }
    return false;
  }

  is_empty() {
    if (this.files) {
      return this.files.length <= 0
    }
    return true
  }
  
  archive_ids!: any
  
  selectRow(checkValue:any) {
    if (checkValue) {
      this.archive_ids = this.archive_ids.filter((file:any)=> !this.file_created_by_admin_demo(file));
    } else {
      this.archive_ids = [];
    }
  }

  file_created_by_admin_demo(file:any){
    if(file.created_by.toLowerCase().trim().includes('demo') || file.created_by.toLowerCase().trim().includes('admin') ){
      return true
    }
    return false
  }

  archive_multiple_files() {
    if(this.archive_ids){
      let ids: any = [];
      this.archive_ids.forEach((file: any) => {
        if(!this.file_created_by_admin_demo(file)){
          ids.push(file._id);
        }
      });

      if(ids.length==0){
        this.messageService.add({severity: 'info', summary: 'No Files Selected', detail: 'Please select atleast one file to delete'})
        this.get_user_files();
      }else{
        this.myFileService.archive_files(ids).subscribe((data: any) => {
          // console.log("successfully archived", data);
          this.get_user_files();
          // this.messageService.add({severity: 'success', summary: 'successfully archived', detail: `successfully archived ${data.length} files`})
           this.messageService.add({severity: 'success', summary: 'successfully archived', detail: `Successfully Archived selected files`})

        })
        this.archive_ids =[];
      }
    }else{
      this.messageService.add({severity: 'info', summary: 'No Files Selected', detail: 'Please select atleast one file to delete'})
    }
  }

  empty_divs(){
    return Array(this.rows - this.files.length).fill({});
  }

  get_cdn_url(path:string){
    return `${environment.storage_cdn_url}/${path}`
  }
}
